import { render, staticRenderFns } from "./NewsCenter.vue?vue&type=template&id=4f1e7a7b&scoped=true&"
import script from "./NewsCenter.vue?vue&type=script&lang=js&"
export * from "./NewsCenter.vue?vue&type=script&lang=js&"
import style0 from "./NewsCenter.vue?vue&type=style&index=0&id=4f1e7a7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1e7a7b",
  null
  
)

component.options.__file = "NewsCenter.vue"
export default component.exports